module.exports = __webpack_public_path__ + "images/emoji/waning_gibbous_moon.dcbc1dc97ecc9f9e8ae9.png";